import { SlideInterface } from '@tencent/docs-api';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IElementNode } from '../../slide-content-enumerator/enumerator-types.interface';
import { BaseAnalyzer } from '../base/base-analyzer';

type SlideIndex = number;

export type IResult = Record<SlideIndex, SlideInterface.ChartReview[]>;

export class MachineChartAnalyzer extends BaseAnalyzer<IResult> {
    private chartReviewList: IResult = []; // 图表检测结果

    public onPresentationStart(): void {
        // 开始的时候重置检测结果
        this.chartReviewList = [];
    }

    public onElement(element: IElementNode): void {
        this.analysisElement(element);
    }

    public async calculateResult(): Promise<IResult> {
        return this.chartReviewList;
    }

    // 分析单个元素节点，存储图片分析结果
    private analysisElement(node: IElementNode) {
        const imageReview = this.getChartReviewFromElement(node.element);
        if (!imageReview) {
            return;
        }
        const { slideIndex } = node.slideNode;
        if (!this.chartReviewList[slideIndex]) {
            this.chartReviewList[slideIndex] = [];
        }
        this.chartReviewList[slideIndex].push(imageReview);
    }

    // 针对不同的图片类型输出单个图片的分析结果
    private getChartReviewFromElement(element: IElementBaseModel): SlideInterface.ChartReview | undefined {
        // 分析图片元素
        if (element.type === UIModelType.CHART) {
            return { element };
        }
        return undefined;
    }
}
